import React, { useEffect, useState } from 'react';

import Title from '../component/common/title';
import MemberNav from '../component/member/member-nav';
import PaginationStatic from '../component/common/pagination-static';
import Discount from '../component/member/discount';

import iconHead from '../img/icon_head.svg';
import IconEmpty from '../img/icon_empty.svg';
import apiService from '../service/apiService';
import { useNavigate, useLocation } from 'react-router';
import SweetAlert2 from 'react-sweetalert2';
import { Default } from 'react-awesome-spinners';

const PageTitle = { pic: iconHead, name: "我的優惠", parent: "會員專區" }
const NavActiveIndex = 2;

function MemberDiscount() {
    const [content, setContent] = useState([])
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [loading, setLoading] = useState(true)
    const [reload, setReload] = useState(true)
    const [swalProps, setSwalProps] = useState({})
    const navigate = useNavigate()
    const location = useLocation()
    // 會員從結帳頁的「選擇優惠券」進來時帶 from=checkout
    const fromCheckout = location.state?.from === 'checkout'

    const showAlert = (title, text) => {
        setSwalProps({
            show: true, title, text,
            icon: 'info',
            confirmButtonColor: '#FCC800',
            iconColor: '#FCC800',
            onConfirm: () => setSwalProps({ show: false }),
        })
    }

    const handlePrev = () => {
        if (page === 1) return
        setPage(page - 1)
    }

    const handleNext = () => {
        if (page === totalPages) return
        setPage(page + 1)
    }

    const handleFirst = () => {
        setPage(1)
    }

    const handleLast = () => {
        setPage(totalPages)
    }

    const handlePageChange = (page) => {
        setPage(page)
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            try {
                const myDiscount = await apiService.getCoupons()
                setContent(myDiscount.content)
                setPage(myDiscount.pageNumber)
                setTotalPages(myDiscount.totalPages)
            } catch (e) {
                console.log(e)
            } finally {
                setLoading(false)
                setReload(false)
            }
        }
        if (reload) {
            fetchData()
        }
    }, [reload])

    const handleUseCoupon = async (couponId) => {
        try {
            const coupon = content.find(c => c.id === couponId)
            // 已在使用中 → 取消使用 (維持原本 toggle 行為)
            if (coupon.isInUse) {
                await apiService.unuseCoupon({ id: couponId })
                setReload(true)
                return
            }
            // 指定系列: 先檢查是否已擁有該系列
            if (coupon.scope === 1) {
                const myLessons = await apiService.getMyLessons()
                const owned = Array.isArray(myLessons) && myLessons.some(l => l.seriesId === coupon.seriesId)
                if (owned) {
                    showAlert('無法使用', `您已擁有「${coupon.seriesName || '該系列'}」，此優惠券無法使用。`)
                    return
                }
            }
            // 標記使用中，結帳時折扣會自動套用
            await apiService.useCoupon({ id: couponId })
            // 從結帳頁進來的: 選好優惠券後直接跳回結帳頁
            if (fromCheckout) {
                navigate('/order')
                return
            }
            // 全站通用: 直接跳到購物車讓使用者選購
            if (coupon.scope === 0) {
                navigate('/cart')
                return
            }
            // 指定系列/方案: 提示使用者把對應商品加入購物車，折扣會自動計算
            setReload(true)
            const target = coupon.scope === 2
                ? (coupon.salesPlanName || '指定方案')
                : (coupon.seriesName || '指定系列')
            showAlert('已套用優惠券', `請將「${target}」加入購物車，結帳時折扣會自動計算。`)
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className='container'>
            <div className="title_content title-member">
                <Title data={PageTitle} />
            </div>
            <div className="member_page page">
                <div className="row">
                    <div className="col-xl-3 col-lg-4 mb-4">
                        <MemberNav active={NavActiveIndex} />
                    </div>
                    <div className="col-xl-9 col-lg-8">
                        <div className="member_content">
                            {loading ? (
                                <div className="loader"><Default color="black" /><p>讀取中</p></div>
                            ) : content && content.length > 0 ? (
                                <div className="row">
                                    {content.map((data, index) => (
                                        <div className="col-lg-6" key={index}>
                                            <Discount discount={data} onUseCoupon={handleUseCoupon} />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="member_empty">
                                    <img src={IconEmpty} alt="" />
                                    <p>這裡空空的...</p>
                                </div>
                            )}
                        </div>
                        {!loading && content && content.length > 0 &&
                            <PaginationStatic
                                page={page}
                                totalPages={totalPages}
                                onPrev={handlePrev}
                                onNext={handleNext}
                                onFirst={handleFirst}
                                onLast={handleLast}
                                onPageChange={handlePageChange}
                            />}
                    </div>
                </div>
            </div>
            <SweetAlert2 {...swalProps} />
        </div>
    );
}

export default MemberDiscount;